import { useMutation, useQueryClient } from "@tanstack/react-query";

import { removeDocument } from "@/adapters/api";
import { documentsQueryKey } from "./use-documents.ts";

export function useRemoveDocument(constructionId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (documentId: string) => {
			if (!constructionId) throw new Error("missing construction");
			await removeDocument(constructionId, documentId);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: documentsQueryKey(constructionId),
			});
		},
	});
}
